import React, {FC} from "react";
import useTranslate from "../../modules/core/languages/hooks/useTranslate";
import BasketItem from "../../modules/booking/types/BasketItem";
import CheckoutItem from "./CheckoutItem";
import ButtonPrimary from "../../modules/ui/shared/Button/ButtonPrimary";
import ButtonSecondary from "../../modules/ui/shared/Button/ButtonSecondary";
import useDeleteAllBasketItems from "../../modules/booking/hooks/useDeleteAllBasketItems";
import useGetPrebooking from "../../modules/booking/hooks/useGetPrebooking";
import LoginOrRegisterMsg from "../../modules/ui/components/LoginOrRegister/LoginOrRegisterMsg";
import useBookingSearchContext from "../../modules/booking/hooks/useBookingSearchContext";
import CheckoutPriceSummary from "./CheckoutPriceSummary";

export interface CheckoutItemListProps {
    prebookingId: string;
    basketItems: BasketItem[];
}

const CheckoutItemList: FC<CheckoutItemListProps> = ({
    prebookingId,
    basketItems,
}) => {
    const t = useTranslate();

    const {save: deleteBasketItems } = useDeleteAllBasketItems();
    const { setPrebookingId } = useBookingSearchContext();

    const prebookingQuery = useGetPrebooking(prebookingId);
    const {data: prebooking} = prebookingQuery;

    const handleClearBasket = () => {
        deleteBasketItems({
            prebookingId: prebookingId
        });
        setPrebookingId(null);
    }

    const renderItem = (data: BasketItem) => {
        return (
            <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8 mb-10" key={data.id}>
                <CheckoutItem item={data} itemCount={basketItems.length}/>
            </div>
        )
    };

    return (
        <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
            <h2 className="text-3xl lg:text-4xl font-semibold">
                {t("checkout.title")}
            </h2>
            <LoginOrRegisterMsg/>
            <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
            <div>
                {basketItems.map((item) => renderItem(item))}
            </div>

            {prebooking && (
                <CheckoutPriceSummary
                    totalWithTaxes={prebooking.totalWithTaxes}
                    totalWithoutTaxes={prebooking.totalWithoutTaxes}
                    taxes={prebooking.taxes}
                    taxRate={basketItems[0].taxRate}
                    discount={prebooking.discount}
                    discountAmount={prebooking.discountAmount}
                    discountPercent={prebooking.discountPercent}
                    totalBasket={prebooking.totalBasket}
                    currencySymbol={basketItems[0].currencySymbol}
                />
            )}

            <div>
                <ButtonPrimary href={"/book"}>
                    <i className={"text-3xl las la-credit-card"}></i>
                    <span className="pl-1">{t("checkout.confirm_booking")}</span>
                </ButtonPrimary>
                <ButtonSecondary onClick={handleClearBasket} className="float-right">{t("checkout.clear_basket")}</ButtonSecondary>
            </div>
        </div>
    );
}

export default CheckoutItemList;
